window.theme = window.theme || {};
window.mod = window.mod || {};

// ################################################################################################################
// GLOBAL UTILS
// ################################################################################################################
var utils = utils || {}

utils.handleize = function(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

// ################################################################################################################
// MOBILE NAV
// ################################################################################################################
theme.MobileNav = (function() {
  var MobileNav = function() {
    this.selectors = {
      $drawerLeft: $('.drawer--left'),
      $toggle: $('.js-mobile-nav-toggle'),
      $close: $('.js-mobile-nav-close'),
      $searchClose: $('.js-drawer-close'),
      $accordionHeader: $('.site-nav__link'),
      $accordionContent: $('.site-nav__sublist')
    }

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryLargeDown: 'screen and (max-width: 1200px)',
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 1200px)'
    };

    this._bindUIEvents();
    
    /*
    *  TODO: left drawer should be moved out of the header and nav section settings should be global.
    *  This is a temp solution to fix mobile scrolling on drawer.
    */
    $('.drawer--left').appendTo('body');
  }

  MobileNav.prototype = _.assignIn({}, MobileNav.prototype, {
    _toggleAccordion: function(evt) {
        var $el = $(evt.currentTarget);
        //if there is a sublist, prevent link from working
        if ($el.siblings('ul').length) {
          evt.preventDefault();

          //toggle accordion content
          $el.siblings('ul').slideToggle();
          $el.find('svg').toggleClass('flipped');
        }
    },

    _bindUIEvents: function() {
      var self = this;

      enquire.register(this.settings.mediaQueryLargeDown, {
        match: function() {
          self.selectors.$toggle.on('click', theme.MobileDrawer.open.bind(theme.MobileDrawer))
          self.selectors.$close.on('click', theme.MobileDrawer.close.bind(theme.MobileDrawer))
          self.selectors.$accordionHeader.on('click', self ._toggleAccordion.bind(self));
        },
        unmatch: function() {
          self.selectors.$toggle.unbind('click');
          self.selectors.$close.unbind('click');
          self.selectors.$accordionHeader.unbind('click');
        }
      });
    }
  });

  return MobileNav;
})();

// ################################################################################################################
// SWATCHES
// ################################################################################################################

theme.Swatches = (function() {
  var Swatches = function() {
    this.selectors = {
      swatchContainer: '.swatch',
      swatch: '.swatch :radio',
      swatchMetaContainer: '.swatch--meta',
      swatchMeta: '.swatch--meta :radio',
      swatchOptionLabel: '.header-option-label',
      singleOptionSelector: '.single-option-selector',
      productPhotos: '.product-single__photos',
      productPhoto: '.product-single__photos img',
      mobileSlider: '.product-single__slider',
      mobileSlide: '.product-single__slide',
      optionSKU: '.option--sku',
      mainSKU: '.line-item--sku'
    }

    //select first option by default
    $(this.selectors.swatchContainer).each(function(){
      $(this).find(':radio').first().trigger('click');
    })

    $(this.selectors.singleOptionSelector).each(function(index){
      var firstOption = $(this).find('option').first().val();
      $(this).find('option').each(function(index){
        if(index == 0){
          $(this).attr('selected','selected');
        }
        else {
          $(this).removeAttr('selected');
        }
      })
    });

    this._triggerChange(this.selectors);
    this._updateSKU(this.selectors);
    this._variantImageSwap(this.selectors);
  }

  Swatches.prototype = _.assignIn({}, Swatches.prototype, {
    _triggerChange: function(selectors) {
      $(selectors.swatch).change(function() {
        var optionIndex = $(this).closest(selectors.swatchContainer).attr('data-option-index');
        var optionValue = $(this).val();

        //update swatch header label text
        $(selectors.swatchOptionLabel).each(function(){
          if ($(this).data('option-index') == optionIndex){
            $(this).text(optionValue);
          }
        })

        //if the swatch is based on custom fields (not real variants)
        //then grab the value before the colon. That links it to the true variant
        if($(this).parents(selectors.swatchMetaContainer).length > 0){
          if(optionValue.includes(':')){
            var optionValueSplit = optionValue.split(':');
            optionValue = optionValueSplit[0].replace(" ", "");
          }
        }

        $(this)
          .closest('form')
          .find(selectors.singleOptionSelector)
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    },
    _variantImageSwap: function(selectors) {

      $(selectors.swatch).change(function() {

        var selectedVariant = '';
        var imageAlt = '';
        var imageFound = false;

        //unfilter mobile slides
        $(selectors.mobileSlider).slick('slickUnfilter');

        //get selected variant after swatch change
        $(selectors.singleOptionSelector).each(function(i){
          if (i==0){
            selectedVariant += $(this).val();
          }
          else{
            selectedVariant += '-' + $(this).val();
          }
        })

        //handleize selected variant
        selectedVariant = utils.handleize(selectedVariant);
		
        //if swatch meta fields are used, update selected variant
        //to use those values instead of the 'true' variant
        if($(selectors.swatchMetaContainer).length > 0){

          //determine how many meta options affect the images
          var optionsThatAffectImages = 0;
          $(selectors.swatchContainer).each(function(){
            if ($(this).data('affects-images') == 'yes'){
              optionsThatAffectImages++;
            }
          })

          if (optionsThatAffectImages > 0){
            //reset selectedVariant
            selectedVariant = '';

            //append selected swatch titles to selectedVariant
            var optionsFound = 0;
            $(selectors.optionSKU).each(function(){
              if($(this).hasClass('selected')){
                if (optionsFound == 0){
                  selectedVariant += $(this).data('title');
                }
                else {
                  if(optionsFound < optionsThatAffectImages){
                    selectedVariant += '-' + $(this).data('title');
                  }
                }
                optionsFound++;
              }
            })
          }
        }

        $(selectors.productPhoto).each(function(){
          //get handleized alt tag for each image
          imageAlt = $(this).attr('alt');

          if(imageAlt.includes(selectedVariant)){
            imageFound = true;
            $(this).addClass('show-img');
          }
          else{
            $(this).removeClass('show-img');
          }
        })

        $(selectors.mobileSlide).each(function(){
          //get handleized data-alt for each mobile slide
          imageAlt = $(this).data('alt');
          
          if(imageAlt.includes(selectedVariant)){
            imageFound = true;
            $(this).addClass('show-img');
          }
          else{
            $(this).removeClass('show-img');
          }
        })


        var imagesToShow = $(selectors.productPhoto).filter('.show-img');
        var imagesToHide = $(selectors.productPhoto).not(imagesToShow);

        if(imageFound == true){
          //filter matching images
          imagesToShow.show();
          imagesToHide.hide();

          // filter matching mobile slides
          $(selectors.mobileSlider).slick('slickFilter','.show-img');

          //scroll to the top of images
          $('html, body').animate({
              scrollTop: $(selectors.productPhotos).offset().top
          }, 600, function(){
          });
        }
        else {
          //show all images if no matching variant
          $(selectors.productPhoto).show();
          $(selectors.mobileSlide).show();

          //unfilter mobile slides
          $(selectors.mobileSlider).slick('slickUnfilter');
        }

        //reset all sizes for scrolling
        resetSizes();

      });
    },
    _updateSKU: function(selectors) {

      //update SKU when swatch changes
      $(selectors.swatch).change(function() {
        var swatchTitle = $(this).data('value-handle');
        var swatchIndex = $(this).data('index');

        //add selected class to correct SKUs
        $(selectors.optionSKU).each(function(){

          if ($(this).data('title') == swatchTitle && $(this).data('index') == swatchIndex){
            $(this).addClass('selected');
          }
          else {
            if($(this).data('index') == swatchIndex){
              $(this).removeClass('selected');
            }
          }
        })

        var lineItemSKU = '';
        var firstSKU = true;

        //grab all selected skus
        $(selectors.optionSKU).each(function(){
          if ($(this).hasClass('selected')){
            lineItemSKU += '-' + $(this).data('sku');
          }
        })

        //remove first dash from sku
        if(lineItemSKU.charAt(0) === '-') lineItemSKU = lineItemSKU.slice(1);

        //set line item SKU
        $(selectors.mainSKU).val(lineItemSKU);
      });

      
      //trigger each first swatch to change on load
      $(selectors.swatchContainer).each(function(){
        $(this).find(':radio').eq(0).change();
      })

    }
  });
  return Swatches;
})();

// ################################################################################################################
// HEADER
// ################################################################################################################

mod.Header = (function() {
  function Header(container) {
    var $container = this.$container = $(container);

    var classes = {
      navItem: '.js-nav-item',
      siteHeaderContainer: '.site-header-container',
      siteHeader: '.site-header',
      siteHeaderUp: 'site-header--up',
      megaMenuContainer: '.mega-menu',
      megaMenuUp: 'mega-menu--up',
			megaMenu: '.mega-menu__inner',
      active: 'mega-menu__inner--active',
      announcementBar: '.announcement-bar',
      mainContent: '.main-content'
		}

    //mega menu is only on large screens > 1200px width
    if (!window.matchMedia('(max-width: 1200px)').matches) {
      this._toggleMegaMenu(classes);
    }
    this._fixedHeader(classes);
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    _toggleMegaMenu: function(classes) {

      $(classes.navItem).hover(function(){
        var blockID = $(this).data('id');
        var $currentItem = $(this);
        $(classes.megaMenu).slideUp();

        //if the same elm is being hovered after
        //the timeout, open mega menu
        setTimeout(function(){
          var isHovered = $currentItem.is(":hover");
          if(isHovered){
            $(classes.megaMenu + '--' + blockID).slideDown();
          }
        }, 300);

      }, function(e){
        //if the cursor left the current item and did NOT go
        //to the mega menu, then hide the mega menu
        if (!$(e.relatedTarget).closest('.mega-menu').length){
          $(classes.megaMenu).slideUp();
        }
      })

      $(classes.navItem).focus(function(){
        var blockID = $(this).data('id');
        var $currentItem = $(this);
        $(classes.megaMenu).slideUp();

        //if the same elm is being hovered after
        //the timeout, open mega menu
        setTimeout(function(){
          var isfocused = $currentItem.is(":focus");
          if(isfocused){
            $(classes.megaMenu + '--' + blockID).slideDown();
          }
        }, 300);

      }, function(e){
        //if the cursor left the current item and did NOT go
        //to the mega menu, then hide the mega menu
        if (!$(e.relatedTarget).closest('.mega-menu').length){
          $(classes.megaMenu).slideUp();
        }
      })

      //hide mega menu on mouseout
      $(classes.megaMenu).off('focus', function(){
      }, function(){
        $(this).slideUp();
      })

    },

    _fixedHeader: function(classes) {
      // Hide Header on on scroll down
      var didScroll;
      var lastScrollTop = 0;
      var delta = 5;
      var navbarHeight = $(classes.siteHeader).outerHeight();
      var announcementHeight = $(classes.announcementBar).outerHeight();

      function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if(Math.abs(lastScrollTop - st) <= delta) return;

        // If they scrolled down and are past the navbar, add class .site-header--up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight){
            // Scroll Down and have header slide up
            $(classes.announcementBar).addClass(classes.siteHeaderUp);
            $(classes.siteHeader).addClass(classes.siteHeaderUp);
            $(classes.megaMenuContainer).addClass(classes.megaMenuUp);
        } else {
            // Scroll Up and show header
            if(st + $(window).height() < $(document).height()) {
              $(classes.announcementBar).removeClass(classes.siteHeaderUp);
                $(classes.siteHeader).removeClass(classes.siteHeaderUp);
                $(classes.megaMenuContainer).removeClass(classes.megaMenuUp);
            }
        }

        lastScrollTop = st;
      }

      function adjustHeights() {
        if ($(classes.announcementBar).is(':visible')) {
          $(classes.siteHeader).css('margin-top', announcementHeight);
          $(classes.megaMenuContainer).css('margin-top', announcementHeight);
          $(classes.mainContent).css('margin-top', (navbarHeight + announcementHeight));
          $('<style>.site-header--up { top: -' + (navbarHeight + announcementHeight) + 'px;}</style>').appendTo('body');
        }
      }

      adjustHeights();
      
      $(window).resize(function(){
        navbarHeight = $(classes.siteHeader).outerHeight();
        announcementHeight = $(classes.announcementBar).outerHeight();
        adjustHeights();
      });
      
    }
  });

  return Header;
})();

// ################################################################################################################
// FADE IN ANIMATIONS
// (Using Scroll Reveal => github.com/jlmakes/scrollreveal.js)
// ################################################################################################################
mod.FadeIn = (function() {
  var FadeIn = function() {
    this.selectors = {
      section: '.section-fader'
    }

    this._initFade();
  }

  FadeIn.prototype = _.assignIn({}, FadeIn.prototype, {
    _initFade: function() {
      window.sr = ScrollReveal();

      // vFactor represents when an element is considered in the viewport.
      // (e.g. 0.30 means 30% of an element must be visible for its reveal to occur.)
      var minVFactor = 0.0;
      var maxVFactor = 0.3;

      var fadeOptions = {
        distance: '60px',
        duration: 700,
        scale: 1,
        reset: true,
        viewFactor: maxVFactor,
        afterReveal: setMinVFactor,
        afterReset: setMaxVFactor
      }

      sr.reveal(this.selectors.section , fadeOptions);

      // pass the dom element to setVFactor() method
      // which re-reveals that element with
      // the new configuration.
      function setVFactor (el, vf) {
        sr.reveal(el, { viewFactor: vf });
      }

      // Callbacks
      function setMinVFactor (el) {
        setVFactor(el, minVFactor);
      }

      function setMaxVFactor (el) {
        setVFactor(el, maxVFactor);
      }
    }
  });


  return FadeIn;
})();

// ################################################################################################################
// SLIDESHOW SECTION
// ################################################################################################################

mod.Slideshow = (function() {
  function Slideshow(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr('data-section-id');

    this.selectors = {
			videos: '.slideshow__slide--video video'
		}

    this._playVideo();
	}

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    _playVideo: function() {
      var self = this;

      $(window).on('load', function(){
         $(self.selectors.videos).each(function(){
           $(this)[0].play();
         })
      })
    }
  });

  return Slideshow; 
})();

// ################################################################################################################
// TRI-SLIDER SECTION
// ################################################################################################################

mod.TriSlider = (function() {
	function TriSlider(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr('data-section-id');

		this.selectors = {
			triSlider: '#TriSlider--' + sectionId,
			triSlide: '.tri-slider__slide--' + sectionId,
      cursor: '.tri-slider__cursor--' + sectionId
		}

    this.settings = {
			breakpointMedium: 750,
      breakpointLarge: 1200,
      breakpointWidescreen: 1400,
			slideCount: 3,
      autoplay: $(this.selectors.triSlider).data('autoplay'),
      speed: $(this.selectors.triSlider).data('speed')
		}

    this._initSlideshow();
    this._drawCursor();
    this._removeCursor();

	}

	TriSlider.prototype = _.assignIn({}, TriSlider.prototype, {
		_initSlideshow: function() {

      var options = {
				slidesToShow: this.settings.slideCount,
				slidesToScroll: 1,
        autoplay: this.settings.autoplay,
        autoplaySpeed: this.settings.speed,
        centerMode: true,
        centerPadding: '0',
				dots: false,
        arrows: false,
        infinite: true,
				responsive: [
          {
  					breakpoint: this.settings.breakpointLarge,
  					settings: {
              slidesToShow: 1,
              centerPadding: '25%'
  					}
  				},
          {
            breakpoint: this.settings.breakpointMedium,
  					settings: {
              slidesToShow: 1,
  						centerPadding: '10%'
  					}
          },
        ]
			}

			$(this.selectors.triSlider).slick(options);
		},

    _drawCursor: function() {
      var $cursor = $(this.selectors.cursor);

      this.$container.bind('mousemove', function(e){
          //position cursor
          $cursor.css({
             left:  e.pageX,
             top:   e.pageY - $(this).offset().top + 50
          });


      });
    },
    _removeCursor: function() {
      var $cursor = $(this.selectors.cursor);
      // hide cursor on swipe
      this.$container.on('swipe', function(event, slick, direction){
        $cursor.fadeOut();
      });

    }

	});

	return TriSlider;
})();

// ################################################################################################################
// FEATURED PRODUCT SLIDER
// ################################################################################################################

mod.FeaturedProductSlider = (function() {
	function FeaturedProductSlider(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr('data-section-id');

		this.selectors = {
			productSlider: '#FeaturedProductSlider--' + sectionId,
			productSlide: '.featured-product-slider__slide--' + sectionId
		}

    this.settings = {
			slideCount: 1,
      autoplay: $(this.selectors.triSlider).data('autoplay'),
      speed: $(this.selectors.triSlider).data('speed')
		}

    this._initSlideshow();

	}

	FeaturedProductSlider.prototype = _.assignIn({}, FeaturedProductSlider.prototype, {
		_initSlideshow: function() {

      var options = {
				slidesToShow: this.settings.slideCount,
				slidesToScroll: 1,
        autoplay: this.settings.autoplay,
        autoplaySpeed: this.settings.speed,
				dots: true,
        arrows: false,
        infinite: true
			}

			$(this.selectors.productSlider).slick(options);
		}

	});

	return FeaturedProductSlider;
})();

// ################################################################################################################
// PRODUCT TEMPLATE
// ################################################################################################################

mod.Product = (function() {
  function Product(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr('data-section-id');

    var selectors = {
      tabButton: '.product-tabs__button--' + sectionId,
			tabText: '.product-tabs__text--' + sectionId,
      swatch: '.swatch',
      swatchMeta: '.swatch--meta',
      singleOptionSelector: '.single-option-selector-' + sectionId,
      mobileSlider: '.product-single__slider--' + sectionId,
      heroSlider: '.product-single__hero-slider',
      qtyInput: '#Quantity'
    }
    

    this._removeCachedVariants();
    this._initSlideshow(selectors);
    this._changeTabs(selectors);
    this._positionSwatches(selectors);
    this._addOnListener(selectors);
    this._qtyListener(selectors);
	}

  Product.prototype = _.assignIn({}, Product.prototype, {
    _removeCachedVariants: function() {
      var currentURL = window.location.href;
      var newURL = currentURL.substring(0, currentURL.indexOf('?'));

      // update url to remove cached variant
      window.history.pushState('remove variants', document.title, newURL);
    },

    _initSlideshow: function(selectors) {
      $(selectors.mobileSlider).slick({lazyLoad: 'ondemand'});
      $(selectors.heroSlider).slick({lazyLoad: 'progressive', dots: true});
    },

		_changeTabs: function(selectors) {

      $(selectors.tabButton).click(function(){
        var currentIndex = $(this).data('tab-index');

        //toggle active button
        $(selectors.tabButton).find('span').removeClass('active');
        $(this).find('span').addClass('active');

        //toggle active text content
        $(selectors.tabText).each(function(){
          $(this).addClass('hide');
          if($(this).data('tab-index') == currentIndex){
            $(this).removeClass('hide');
          }
        })

        //recalculate heights
        resetSizes();

      })
		},

    _positionSwatches: function(selectors) {
      var swatches = [];

      //push swatches to array
      $(selectors.swatch).each(function(){
        swatches.push(this);
      })

      //sort swatches
      swatches.sort(function(a, b) {
          return parseFloat(a.getAttribute('data-swatch-index')) - parseFloat(b.getAttribute('data-swatch-index'));
      });

      //append swatches
      $('.swatches-below').after(swatches);
    },

    _addOnListener: function(selectors) {
      $('input[name="add-on"]').change(function() {
        if($(this).is(":checked")) {
            $('.price--base').hide();
            $('.price--add-on').show();
            $(this).addClass('extra-product--selected'); // NOTE: for minicart
        }
        else {
          $('.price--add-on').hide();
          $('.price--base').show();
          $(this).removeClass('extra-product--selected'); // NOTE: for minicart
        }
      });
    },

    _qtyListener: function (selectors) {
      $(selectors.qtyInput).on('change', function (e) {
        var qty = $(e.target).val();

        qty = parseInt(qty);

        if (!qty || isNaN(qty) || qty < 0) {
          qty = 1;
        }

        $('.minicart-add-on-hidden').attr('data-quantity', qty);
      });
    }

	});

  return Product;
})();

// ################################################################################################################
// COLLECTION TEMPLATE
// ################################################################################################################

mod.Collection = (function() {
  function Collection(container) {
		var $container = this.$container = $(container);
		var sectionId = $container.attr('data-section-id');

    var selectors = {
      filters: '.collection-items__filters--' + sectionId,
      filtersTrigger: '.filters__trigger--' + sectionId,
      filterMenu: '.filter-menu',
      collectionSlider: '.collection-slider--' + sectionId,
      collectionSlide: '.collection-slide',
      activeSlide: '.slick-current'
		}

    this._toggleFilters(selectors);
    this._initCollectionSlider(selectors)
	}

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    _toggleFilters: function(selectors) {
      $(selectors.filtersTrigger).click(function(){
        if($(this).hasClass('js-closed')){
          $(this).html('< <span>&nbsp;Hide Filters</span>');
        }
        else {
          $(this).html('> <span>&nbsp;Show Filters</span>');
        }

        $(selectors.filters).toggle();
        $(this).toggleClass('js-closed');
        $(selectors.filters).find(selectors.filterMenu).toggleClass('pt-expand');
      })
    },
    _initCollectionSlider: function(selectors) {
      $(selectors.collectionSlider).slick({
        draggable: true,
        arrows: true,
        nextArrow: '<img class="next-arrows" src="https://cdn.shopify.com/s/files/1/0022/2258/7969/files/white-right-arrow.png?13684787434202739925"/>',
        prevArrow: '<img class="prev-arrows" src="https://cdn.shopify.com/s/files/1/0022/2258/7969/files/white-left-arrow.png?13684787434202739925"/>'
      });

      //if first slide contains a video, play it
      if ($(selectors.activeSlide).find('video').length > 0){
        //if video has a placeholder image, wait 3 seconds befor playing video
        if ($(selectors.activeSlide).find('video')[0].hasAttribute('poster')){
          setTimeout(function(){ $(selectors.activeSlide).find('video')[0].play(); }, 5000);
        }
        else {
          $(selectors.activeSlide).find('video')[0].play();
        }
      }

      //control videos on slide change
      $(selectors.collectionSlider).on('afterChange', function(event, slick, currentSlide){

        $(selectors.collectionSlide).each(function(){
          //if inactive slide has video, pause it
          // if(!$(this).hasClass('slick-current') && $(this).find('video').length > 0){
          //   $(this).find('video')[0].pause();
          // }

          //if current slide has video, play it
          if($(this).hasClass('slick-current') && $(this).find('video').length > 0){
            //if video has a placeholder image, wait 3 seconds befor playing video
            if ($(selectors.activeSlide).find('video')[0].hasAttribute('poster')){
              setTimeout(function(){ $(selectors.activeSlide).find('video')[0].play(); }, 1500);
            }
            else {
              $(selectors.activeSlide).find('video')[0].play();
            }
          }
        })

      })
    }
  });

  return Collection;
})();

$(document).ready(function(){
  //init left drawer
  theme.MobileDrawer = new theme.Drawers('shopify-section-mobile-menu', 'left', {})
  //init mobile nav (inside left drawer)
  new theme.MobileNav();
  //init product Swatches
  new theme.Swatches();
  //init fade in sections
  new mod.FadeIn();

  var sections = new theme.Sections();

  // register new sections
  sections.register('header-section', mod.Header);
  sections.register('slideshow-section', mod.Slideshow);
  sections.register('tri-slider', mod.TriSlider);
  sections.register('vid-product', mod.FeaturedProductSlider);
  sections.register('product', mod.Product);
  sections.register('collection-template', mod.Collection);
})


// ################################################################################################################
// QUICK ADDITIONS
// ################################################################################################################

var iconArrowRight = '<img class="next-arrows" src="https://cdn.shopify.com/s/files/1/0022/2258/7969/files/black-right-arrow.png?13684787434202739925"/>';
var iconArrowLeft = '<img class="prev-arrows"  src="https://cdn.shopify.com/s/files/1/0022/2258/7969/files/black-left-arrow.png?13684787434202739925"/>';

/*================ ABOUT PAGE ================*/
// Main Slick Slider
$(".about-main-slider").slick({
  nextArrow: iconArrowRight,
  prevArrow: iconArrowLeft
});

// Multi Image Slick Slider
$(".about-multiple-slider").slick({
  nextArrow: iconArrowRight,
  prevArrow: iconArrowLeft,
  centerMode: true,
  centerPadding: '25%',
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
})

// Image with Text Slick Slider
$(".image-with-text-slider").slick({
  nextArrow: iconArrowRight,
  prevArrow: iconArrowLeft
});

/*================ COLLABORATION PAGE ================*/
// Main Slider
$(".collab-page-slider").slick({
  nextArrow: iconArrowRight,
  prevArrow: iconArrowLeft
});

/*================ COLLABORATION ARTICLE ================*/
// Main Slider
$(".article__collab-slider").slick({
  lazyLoad: 'progressive',
  nextArrow: iconArrowRight,
  prevArrow: iconArrowLeft
});

/*================ STORE LOCATOR PAGE ================*/

$(".store-locator__slider").slick({
  lazyLoad: 'progressive',
  nextArrow: iconArrowRight,
  prevArrow: iconArrowLeft
});
